/// <amd-module name="Dashboards/DashboardTemplates/DashboardTemplateUtilities" />
import { Widget } from "Dashboards/Common/Contracts/Dashboard";

import { TemplateDataEntry } from "./TemplateData";

/**
 * Creates widgets to place on the dashboard from the specifications of the requested template.
 * @param requestedTemplate the identifier of the template to create widgets from
 * @param availableWidgets the widgets available to use
 */
export function createTemplateWidgets(requestedTemplate: string, availableTemplates: TemplateDataEntry[], availableWidgets: Widget[]) {
    const templateWidgets: Widget[] = [];
    const templateToCheck = availableTemplates.find(templateData => templateData.type === requestedTemplate);
    if (templateToCheck !== undefined) {
        const templateToCreate = templateToCheck;
        templateToCreate.widgets.forEach(requiredWidget => {
            const widgetToCheck = availableWidgets.find(widgetType => widgetType.contributionId === requiredWidget.contributionId);
            if (widgetToCheck !== undefined) {
                const widgetToCreate = widgetToCheck;
                widgetToCreate.size = requiredWidget.size;
                widgetToCreate.position = requiredWidget.position;
                // Keeps default widget settings if not supplied
                widgetToCreate.settings = requiredWidget.settings ? requiredWidget.settings : widgetToCreate.settings;
                widgetToCreate.id = requiredWidget.id;
                templateWidgets.push(widgetToCreate);
            }
        });
    }
    return templateWidgets;
}
